<template>
  <div
    @click.self="closeModal"
    class="Overlay"
    data-action="close-modal"
    v-if="visible"
  >
    <div
      class="ModalBox ModalBox--central Modal--filters"
      id="NewUserModal"
    >

      <div class="ModalBox-header d-flex justify-content-between align-items-center position-absolute p-3">
        <div class="Tit Tit--modal position-absolute w-100">
          <span v-t="{ path: 'customer_creation_header' }"></span>
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#close-icon"></use>
          </svg>
        </div>
        <!--div.Link.Link--action Clear-->
        <button
          v-if="!initializingConfig"
          type="submit"
          form="customer-form"
          class="Fuell-Button blue"
          :disabled="!canBeSubmitted"
        >
          <span
            class="Button-lit"
            v-t="{ path: 'customer_creation_invite_customer' }"
          ></span>
        </button>
      </div>
      <div
        class="ModalBox-container position-relative pl-3 pr-3 pt-3 pb-4"
        v-if="!initializingConfig"
      >
        <form
          class="Form p-2 mt-5 mx-4"
          id="customer-form"
          @submit.prevent="createCustomer"
        >

          <!-- BLOQUE1 : SOCIEDAD --->

          <p v-t="{ path: 'customer_information_header' }"></p>
          <div class="row mt-2">
            <div class="col-12 col-lg-6">
              <div
                class="input--block"
                v-focus-input
              >
                <label
                  class="form--label u-required"
                  for="customer-name"
                >{{
                  $t('customer_creation_social_reason').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.customerSignUpForm.name.$error }"
                >
                  <input
                    class="Input-text"
                    type="text"
                    name="customer-name"
                    v-model.trim="customerSignUpForm.name"
                    :placeholder="$t('customer_creation_social_reason')"
                    @blur="$v.customerSignUpForm.name.$touch()"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div
                class="input--block"
                v-focus-input
              >
                <label
                  class="form--label u-required"
                  for="registration-number"
                > {{ $t(
                  'customer_creation_registration_number').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.customerSignUpForm.registrationNumber.$error }"
                >
                  <input
                    class="Input-text"
                    type="text"
                    name="registration-number"
                    @blur="$v.customerSignUpForm.registrationNumber.$touch()"
                    :placeholder="$t('customer_creation_registration_number')"
                    v-model.trim="customerSignUpForm.registrationNumber"
                  >
                </div>
              </div>
            </div>

          </div>
          <!--- FIN BLOQUE SOCIEDAD --->
          <!-- BLOQUE  DOMICILIO SOCIAL / DIRECCION DE FACTURACION --->
          <div class="row">
            <p
              class="px-3 my-2"
              v-t="{ path: 'customer_creation_social_or_billing_information' }"
            ></p>
          </div>
          <div class="row mt-2">
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="office-address"
                > {{ $t('ADDRESS').toUpperCase() }}</label>
                <div
                  class="Form-field "
                  :class="{ 'Form--field-error': $v.officeForm.fiscalAddress.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="office-address"
                    class="Input-text"
                    @blur="$v.officeForm.fiscalAddress.$touch()"
                    :placeholder="$t('ADDRESS_PLACEHOLDER')"
                    v-model.trim="officeForm.fiscalAddress"
                  >
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="office-city"
                >
                  {{ $t('CITY').toUpperCase() }}
                </label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.officeForm.fiscalCity.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="office-city"
                    class="Input-text"
                    @blur="$v.officeForm.fiscalCity.$touch()"
                    :placeholder="$t('CITY')"
                    v-model.trim="officeForm.fiscalCity"
                  >
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="office-zip"
                > {{ $t('ZIP').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.officeForm.fiscalZipCode.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="office-zip"
                    class="Input-text"
                    @blur="$v.officeForm.fiscalZipCode.$touch()"
                    :placeholder="$t('ZIP')"
                    v-model.trim="officeForm.fiscalZipCode"
                  >
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-2">

            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="office-state"
                >
                  {{ $t('STATE').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.officeForm.fiscalState.$error }"
                >
                  <input
                    type="text"
                    class="Input-text"
                    name="state"
                    :placeholder="$t('STATE')"
                    v-model.trim="officeForm.fiscalState"
                    @blur="$v.officeForm.fiscalState.$touch()"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="office-country"
                > {{ $t('COUNTRY').toUpperCase() }}</label>
                <div
                  class="Form-field required"
                  v-focus-input
                >
                  <input-select
                    :dataCollection="countries"
                    :placeholder="'COUNTRY'"
                    :defaultSelected="'ES'"
                    :fieldForDefaultSelected="'isoCode'"
                    ignoreItemTranslation
                    @input="setItemId('officeForm', 'fiscalCountry', $event)"
                  />

                </div>
              </div>
            </div>
          </div>

          <!--- FIN BLOQUE DOMICILIO SOCIAL  / DIRECCION DE FACTURACIÓN -->
          <!-- BLOQUE USO DE TARJETAS -->
          <div class="mt-3">
            <p v-t="{ path: 'customer_creation_office_configuration' }"></p>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >
                  {{ $t('customer_creation_office_card_usage').toUpperCase() }}
                </label>
                <div class="d-flex align-items-center">
                  <div class="Form-field Form--field-multiselect col-11">
                    <div class="pl-0  multiselect-container">
                      <multiselect
                        class=""
                        :options="officeCardUsageTypes"
                        :customLabel="translateOfficeCardType"
                        v-model="officeForm.officeCardsType"
                        :placeholder="$t('customer_creation_office_card_usage')"
                        :selectLabel="''"
                        :searchable="false"
                        :selectedLabel="''"
                        :deselectLabel="''"
                        @input="setAdminCardType($event)"
                      >
                        <div
                          class="caret"
                          slot="caret"
                          slot-scope="{ toggle }"
                          @mousedown.prevent.stop="toggle"
                        >
                          <i
                            class="Ctrl Ctrl--16"
                            aria-hidden="true"
                          >
                            <svg
                              focusable="false"
                              aria-hidden="true"
                              aria-label="Edit"
                            >
                              <use xlink:href="#dropdown-icon"></use>
                            </svg>
                          </i>
                        </div>
                        <template v-slot:noOptions>
                          {{ '' }}
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <info-display
                    :infoText="$t('customer_creation_office_card_usage_tooltip')"
                    class="col-1"
                    style="width:24px; height:24px;"
                  />

                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <div class="input--block">
                <label
                  for=""
                  class="form--label u-required"
                >
                  {{ $t('customer_creation_zoho_pricing_plan').toUpperCase() }}
                </label>
                <div class="d-flex align-items-center">
                  <div class="Form-field Form--field-multiselect col-11">
                    <div class="pl-0  multiselect-container">
                      <multiselect
                        class=""
                        :options="customerTypes"
                        :customLabel="generateCustomerTypeLabel"
                        v-model="customerType"
                        :placeholder="$t('customer_creation_zoho_pricing_plan')"
                        :selectLabel="''"
                        :searchable="false"
                        :selectedLabel="''"
                        :deselectLabel="''"
                      >
                        <div
                          class="caret"
                          slot="caret"
                          slot-scope="{ toggle }"
                          @mousedown.prevent.stop="toggle"
                        >
                          <i
                            class="Ctrl Ctrl--16"
                            aria-hidden="true"
                          >
                            <svg
                              focusable="false"
                              aria-hidden="true"
                              aria-label="Edit"
                            >
                              <use xlink:href="#dropdown-icon"></use>
                            </svg>
                          </i>
                        </div>
                        <template v-slot:noOptions>
                          {{ '' }}
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <info-display
                    :infoText="$t('customer_creation_zoho_pricing_plan_tooltip')"
                    class="col-1"
                    style="width:24px; height:24px;"
                  />

                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  class="form--label u-required"
                  for="office-invoice"
                >{{ $t('OFFICE_USERS_TO_INVOICE').toUpperCase()
                }}</label>
                <div class="Form-field required">
                  <input
                    type="number"
                    name="office-invoice"
                    v-model.number="customerSignUpForm.usersToInvoiceFloor"
                    :placeholder="$t('customer_new_customer_user_to_invoice')"
                    class="Input-text"
                  >
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label"
                >{{ $t('customer_new_customer_billing_starts_at').toUpperCase()
                }}</label>
                <date-picker-input
                  :mode="'date'"
                  :placeholder="'customer_new_customer_billing_starts_at_placeholder'"
                  :value="customerSignUpForm.billingStartsAt"
                  @inputDate="setBillingStartsAt($event)"
                />
              </div>

            </div>
            <div class="col-12">
              <div class="container-devoluiva-checkbox">
                <input-checkbox
                  id='devoluiva'
                  :value.sync='customerSignUpForm.isDevoluivaActivated'
                >
                  <span
                    class="checkbox-label"
                    slot="input-label"
                  >
                    {{ $t('customer_new_customer_devoluiva') }}
                  </span>
                </input-checkbox>
              </div>
            </div>
          </div>
          <!----->
          <div class="mt-4">
            <p
              class=""
              v-t="{ path: 'customer_creation_fuell_admin_data' }"
            ></p>

          </div>
          <!-- BLOQUE ADMIN CUENTA FUELL --->

          <!--- FIN BLOQUE ADMIN CUENTA FUELL-->
          <div class="row mt-2 mb-2">
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="admin-name"
                >{{ $t('NAME').toUpperCase() }}</label>
                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.adminOfficeInformation.firstName.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="admin-name"
                    class="Input-text"
                    :placeholder="$t('NAME')"
                    @blur="$v.adminOfficeInformation.firstName.$touch()"
                    v-model.trim="adminOfficeInformation.firstName"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="last-name"
                >{{ $t('LAST_NAME').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.adminOfficeInformation.lastName.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="last-name"
                    class="Input-text"
                    :placeholder="$t('LAST_NAME')"
                    @blur="$v.adminOfficeInformation.lastName.$touch()"
                    v-model.trim="adminOfficeInformation.lastName"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="admin-email"
                >{{ $t('EMAIL').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.adminOfficeInformation.email.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="admin-email"
                    class="Input-text"
                    @blur="$v.adminOfficeInformation.email.$touch()"
                    :placeholder="$t('EMAIL')"
                    v-model.trim="adminOfficeInformation.email"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 mt-2">
              <div class="input--block">
                <label
                  class="form--label"
                  for="admin-email"
                >{{
                  $t('customer_creation_fuell_admin_card_usage').toUpperCase() }}</label>
                <div class="d-flex align-items-center">
                  <div
                    class="Form-field Form--field-multiselect col-11"
                    v-focus-input
                  >
                    <div class="pl-0 multiselect-container">
                      <multiselect
                        :options="userCardUsageTypes"
                        :customLabel="translateUserCardType"
                        :disabled="disableCardTypeSelectForAdmin"
                        :placeholder="$t('customer_creation_fuell_admin_card_usage')"
                        :selectLabel="''"
                        :searchable="false"
                        :selectedLabel="''"
                        :deselectLabel="''"
                        v-model="adminOfficeInformation.userCardsType"
                      >
                        <div
                          class="caret"
                          slot="caret"
                          slot-scope="{ toggle }"
                          @mousedown.prevent.stop="toggle"
                        >
                          <i
                            class="Ctrl Ctrl--16"
                            aria-hidden="true"
                          >
                            <svg
                              focusable="false"
                              aria-hidden="true"
                              aria-label="Edit"
                            >
                              <use xlink:href="#dropdown-icon"></use>
                            </svg>
                          </i>
                        </div>
                      </multiselect>
                    </div>
                  </div>
                  <info-display
                    :infoText="$t('customer_creation_fuell_admin_card_usage_tooltip')"
                    class="col-1"
                    style="width:24px; height:24px;"
                  />
                </div>
              </div>

            </div>
            <div
              class="col-12 mt-2 ml-1"
              v-if="adminOfficeInformation.userCardsType && adminOfficeInformation.userCardsType !== 'USER_CARDS_WITHOUT'"
            >
              <label
                for=""
                class="form--label"
              >{{ $t('customer_creation_fuell_admin_card_type_emission').toUpperCase()
              }}</label>
              <div class="d-flex ">
                <input-radio
                  :label="'transactions_card_type__MEMBER_PHYSICAL'"
                  :itemValue="adminOfficeInformation.typeOfCardWhenRegisteredOnIssuer"
                  :value="cardEmissionTypes.PHYSICAL"
                  @click="setAdminTypeOfCard"
                ></input-radio>
                <input-radio
                  :label="'transactions_card_type__MEMBER_VIRTUAL'"
                  :itemValue="adminOfficeInformation.typeOfCardWhenRegisteredOnIssuer"
                  :value="cardEmissionTypes.VIRTUAL"
                  @click="setAdminTypeOfCard"
                ></input-radio>
              </div>
            </div>
          </div>

    <!--- BLOQUE ATTORNEY -->
              <div class="mt-4">
            <p
              class=""
              v-t="{ path: 'customer_creation_fuell_attorney_data' }"
            ></p>

          </div>

             <div class="row mt-2 mb-2">
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="admin-name"
                >{{ $t('NAME').toUpperCase() }}</label>
                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.attorney.firstName.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="admin-name"
                    class="Input-text"
                    :placeholder="$t('NAME')"
                    @blur="$v.attorney.firstName.$touch()"
                    v-model.trim="attorney.firstName"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="last-name"
                >{{ $t('LAST_NAME').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.attorney.lastName.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="last-name"
                    class="Input-text"
                    :placeholder="$t('LAST_NAME')"
                    @blur="$v.attorney.lastName.$touch()"
                    v-model.trim="attorney.lastName"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label u-required"
                  for="admin-email"
                >{{ $t('customer_new_customer_attorney_document').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.attorney.document.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="attorney-document"
                    class="Input-text"
                    @blur="$v.attorney.document.$touch()"
                    :placeholder="$t('customer_new_customer_attorney_document')"
                    v-model.trim="attorney.document"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 mt-2">
                <div class="input--block">
                <label
                  class="form--label u-required"
                  for="attorney-date-of-birth"
                >{{ $t('customer_new_customer_attorney_date_of_birth').toUpperCase() }}</label>

                <date-picker-input
                :errorClass="$v.attorney.dateOfBirth.$error"
                :placeholder="'customer_new_customer_attorney_date_of_birth'"
                :mode="'date'"
                :value="attorney.dateOfBirth"
                @inputDate="setAttorneyBirthDate"
                @hide="$v.attorney.dateOfBirth.$touch()"
                />

              </div>
            </div>
                       <div class="col-12 col-lg-4 mt-2">
              <div class="input--block">

                <label
                  class="form--label u-required"
                  for="attorney-country"
                >{{ $t('COUNTRY').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.attorney.country.$error }"
                  v-focus-input
                >
                  <input-select
                    :dataCollection="countries"
                    :placeholder="'COUNTRY'"
                    :defaultSelected="'ES'"
                    :fieldForDefaultSelected="'isoCode'"
                    ignoreItemTranslation
                    @input="setItemId('attorney', 'country', $event)"
                  />

                </div>
              </div>
            </div>

          </div>
          <!-- FIN BLOQUE ATTORNEY -->

          <!-- GRABADO EN TARJETAS --->
          <div class="mt-3">
            <p
              class=""
              v-t="{ path: 'customer_creation_card_record' }"
            ></p>

          </div>
          <div class="row mt-3">
            <div class="col-12 col-lg-12">
              <div class="input--block">

                <label
                  class="form--label u-required"
                  for="office-name"
                >{{
                  $t('customer_creation_card_company_name_on_record').toUpperCase() }}</label>
                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.officeForm.name.$error }"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="office-name"
                    class="Input-text"
                    :placeholder="$t('customer_creation_card_company_name_on_record')"
                    @blur="$v.officeForm.name.$touch()"
                    v-model.trim="officeForm.name"
                  >
                </div>
              </div>

            </div>
          </div>
          <!--- FIN GRABADO EN TARJETAS --->
          <!-- DIRECCION DE ENVIO DE TARJETAS -->
          <div class="mt-3">
            <p
              class=""
              v-t="{ path: 'customer_creation_card_send_address' }"
            ></p>

          </div>

          <div class="row mt-3">
            <div class="col-12 col-lg-4">
              <div class="input--block">

                <label
                  for=""
                  class="form--label u-required"
                >{{ $t('ADDRESS').toUpperCase() }}</label>
                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.officeForm.address.$error }"
                >
                  <input
                    type="text"
                    name=""
                    :placeholder="$t('ADDRESS_PLACEHOLDER')"
                    v-model.trim="officeForm.address"
                    @blur="$v.officeForm.address.$touch()"
                    class="Input-text"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  for=""
                  class="form--label u-required"
                > {{ $t('CITY').toUpperCase() }}</label>

                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.officeForm.city.$error }"
                >
                  <input
                    type="text"
                    name=""
                    :placeholder="$t('CITY')"
                    class="Input-text"
                    @blur="$v.officeForm.city.$touch()"
                    v-model.trim="officeForm.city"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  for=""
                  class="form--label u-required"
                >{{ $t('ZIP').toUpperCase() }}</label>
                <div
                  class="Form-field required"
                  :class="{ 'Form--field-error': $v.officeForm.zipCode.$error }"
                >
                  <input
                    type="text"
                    name=""
                    @blur="$v.officeForm.zipCode.$touch()"
                    :placeholder="$t('ZIP')"
                    class="Input-text"
                    v-model.trim="officeForm.zipCode"
                  >
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  for=""
                  class="form--label u-required"
                > {{ $t('STATE').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.officeForm.state.$error }"
                >
                  <input
                    type="text"
                    name=""
                    :placeholder="$t('STATE')"
                    class="Input-text"
                    v-model.trim="officeForm.state"
                    @blur="$v.officeForm.state.$touch()"
                  >
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-4">
              <div class="input--block">

                <label
                  class="form--label u-required"
                  for="office-country"
                >{{ $t('COUNTRY').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  :class="{ 'Form--field-error': $v.officeForm.country.$error }"
                  v-focus-input
                >
                  <input-select
                    :dataCollection="countries"
                    :placeholder="'COUNTRY'"
                    :defaultSelected="'ES'"
                    :fieldForDefaultSelected="'isoCode'"
                    ignoreItemTranslation
                    @input="setItemId('officeForm', 'country', $event)"
                  />

                </div>
              </div>
            </div>
            <div class="col_12 col-md-12">
              <div
                class="col-12 mt-2 d-flex"
                v-if="officeForm.officeCardsType && officeForm.officeCardsType !== 'OFFICE_CARDS_WITHOUT'"
              >
                <input-checkbox
                  :id="'shipper-addres-check'"
                  :value.sync="officeForm.sendCardToOffice"
                  @click="setShipperAddress"
                >
                  <template v-slot:input-label>
                    <span class="Fuell-Text ml-2">{{ $t('customer_new_customer_allow_shipping_address') }}</span>
                  </template>
                </input-checkbox>
                <info-display
                  :infoText="$t('customer_new_customer_allow_shipping_address_info')"
                  class="col-1"
                  style="width:24px; height:24px;"
                />

              </div>
            </div>
          </div>
          <!--- FIN DIRECCION DE ENVIO DE TARJETAS -->
          <!-- OTROS DATOS --->
          <!-- FIN BLOQUE OTROS DATOS -->

          <!--- DATA FROM OFFICE -->

          <div class="row">
            <p
              class="px-3 my-2"
              v-t="{ path: 'customer_creation_office_other' }"
            ></p>

          </div>

          <div class="row mt-1">
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label"
                  for="office-contact"
                >{{
                  $t('customer_creation_office_contact_person').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="office-contact"
                    class="Input-text"
                    :placeholder="$t('customer_creation_office_contact_person')"
                    v-model.trim="officeForm.contactPerson"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label"
                  for="office-board"
                >{{
                  $t('customer_creation_office_board_members').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    type="text"
                    name="office-board"
                    class="Input-text"
                    :placeholder="$t('customer_creation_office_board_members')"
                    v-model.trim="officeForm.boardMembers"
                  >

                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label"
                  for="office-current-balance"
                >
                  {{ $t('customer_creation_office_current_balance').toUpperCase() }}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    type="number"
                    min=0
                    name="office-current-balance"
                    class="Input-text"
                    :placeholder="$t('customer_creation_office_current_balance')"
                    v-model.number="officeForm.currentBalance"
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12 col-lg-4">
              <div class="input--block">
                <label
                  class="form--label"
                  for="office-balance-alert"
                >
                  {{ $t('customer_creation_office_balance_alert_threeshold').toUpperCase() }}
                </label>
                <div class="Form-field">
                  <input
                    type="number"
                    min=0
                    name="office-balance-alert"
                    class="Input-text"
                    :placeholder="$t('customer_creation_office_balance_alert_threeshold')"
                    v-model.number="officeForm.balanceAlertThreeshold"
                  >

                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">

                <label
                  class="form--label"
                  for="office-currency"
                > {{ $t('CURRENCY').toUpperCase() }}</label>
                <div class="Form-field required">
                  <input-select
                    :dataCollection="currencies"
                    :placeholder="'CURRENCY'"
                    :defaultSelected="'EUR'"
                    :fieldForDefaultSelected="'code'"
                    ignoreItemTranslation
                    @input="setItemId('officeForm', 'currency', $event)"
                  />

                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="input--block">

                <label
                  class="form--label u-required"
                  for="office-employees"
                >{{ $t('OFFICE_TOTAL_EMPLOYEES').toUpperCase()
                }}</label>
                <div class="Form-field required">
                  <input
                    type="text"
                    name="office-employees"
                    v-model.number="officeForm.employeesCount"
                    id=""
                    class="Input-text"
                  >
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
      <div
        class="ModalBox-container position-relative pl-3 pr-3 pt-3 pb-4"
        v-else
      >
        <div class="w-100 mt-5 d-flex justify-content-center align-items-center">
          <spinner />

        </div>
      </div>

      <!-- END OF OFFICE -->
    </div>

  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import InputSelect from '@/components/Commons/Forms/InputSelect'
import InputRadio from '@/components/Commons/Forms/InputRadio'
import InputCheckbox from '@/components/Commons/Forms/InputCheckbox'
import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'

import Multiselect from 'vue-multiselect'
import InfoDisplay from '@/components/Commons/InfoDisplay'
import Spinner from '@/components/Commons/Spinner'
import utils from '@/utils/utils'

import { CARD_EMISSION_TYPE } from '../../_constants/constants'
import { isEmpty } from 'lodash-es'
const { validationMixin } = require('vuelidate')
const { required, email, alphaNum } = require('vuelidate/lib/validators')

function initialCustomerState () {
  return {
    customerSignUpForm: {
      name: '',
      registrationNumber: '',
      usersToInvoiceFloor: undefined,
      billingStartsAt: undefined
    },
    officeForm: {
      name: '',
      registrationNumber: '',
      address: '',
      fiscalAddress: '',
      fiscalZipCode: '',
      fiscalState: '',
      fiscalCity: '',
      fiscalCountry: {},
      state: '',
      zipCode: '',
      city: '',
      contactPerson: '',
      boardMembers: '',
      currency: {},
      country: {},
      currentBalance: 0,
      balanceAlertThreeshold: 0,
      employeesCount: 0,
      // TODO: Change with the proper data when implemented
      cardIssuer: { id: 1 },
      officeCardsType: '',
      sendCardToOffice: false
    },

    adminOfficeInformation: {
      firstName: '',
      lastName: '',
      email: '',
      userCardsType: '',
      typeOfCardWhenRegisteredOnIssuer: CARD_EMISSION_TYPE.PHYSICAL
    },
    attorney: {
      firstName: '',
      lastName: '',
      document: '',
      dateOfBirth: '',
      country: { id: 1 }
    },
    customerType: '',
    initializingConfig: false

  }
}
export default {
  name: 'NewCustomerModal',
  mixins: [_modalHandlerMixin, validationMixin, utils],
  data () {
    return initialCustomerState()
  },
  components: { InputSelect, Multiselect, InfoDisplay, Spinner, DatePickerInput, InputRadio, InputCheckbox },
  computed: {
    publicConfig () {
      return this.$store.getters['ConfigStore/publicConfig']
    },
    privateConfig () {
      return this.$store.getters['ConfigStore/privateConfig']
    },
    countries () {
      return !isEmpty(this.publicConfig) ? this.$store.getters['ConfigStore/publicConfig'].countries.filter(el => el.shippingAddressEnabled) : []
    },
    currencies () {
      return !isEmpty(this.publicConfig) ? this.$store.getters['ConfigStore/publicConfig'].currencies : []
    },
    officeCardUsageTypes () {
      return !isEmpty(this.privateConfig) ? this.privateConfig.office_cards_type : []
    },
    userCardUsageTypes () {
      return !isEmpty(this.privateConfig) ? this.privateConfig.user_cards_type : []
    },
    customerTypes () {
      return this.$store.getters['ConfigStore/zohoPlans'].customer_types || []
    },

    canBeSubmitted () {
      return !this.$v.$invalid
    },
    cardEmissionTypes () {
      return CARD_EMISSION_TYPE
    },
    errors () {
      return this.$store.getters['CustomersStore/errors']
    },
    disableCardTypeSelectForAdmin () {
      if (this.officeForm.officeCardsType === 'OFFICE_CARDS_OPTIONAL') {
        return false
      }
      return true
    }
  },
  methods: {
    setAdminCardType (event) {
      if (event === 'OFFICE_CARDS_ALWAYS') {
        this.adminOfficeInformation.userCardsType = 'USER_CARDS_ALWAYS'
      }
      if (event === 'OFFICE_CARDS_WITHOUT') {
        this.adminOfficeInformation.userCardsType = 'USER_CARDS_WITHOUT'
      }
      if (event === 'OFFICE_CARDS_OPTIONAL') {
        this.adminOfficeInformation.userCardsType = ''
      }
    },
    setItemId (itemForm, itemKey, event) {
      if (event && event.target) {
        this[itemForm][itemKey] = { id: Number.parseInt(event.target.value) }
      } else {
        this[itemForm][itemKey] = { id: Number.parseInt(event.id) }
      }
    },
    translateOfficeCardType (value) {
      return this.$t(`office_card_usage_type__${value}`)
    },
    translateUserCardType (value) {
      return this.$t(`user_card_usage_type__${value}`)
    },
    generateCustomerTypeLabel (value) {
      let label = ''
      if (value.costPerCard !== 0) {
        label += `${value.name} - Coste por tarjeta : ${this.$options.filters.currency(value.costPerCard, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' })}`
      } else {
        label += `${value.name} - Coste fijo: ${this.$options.filters.currency(value.monthlyFixedCost, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' })} - Coste por tarjeta : ${this.$options.filters.currency(value.costPerCard, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' })}`
      }

      return label
    },
    setBillingStartsAt (event) {
      this.customerSignUpForm.billingStartsAt = event
    },
    setAttorneyBirthDate (event) {
      this.attorney.dateOfBirth = event
    },
    setAdminTypeOfCard (event) {
      this.adminOfficeInformation.typeOfCardWhenRegisteredOnIssuer = event
    },
    setShipperAddress (event) {
      this.officeForm.sendCardToOffice = event
    },
    async createCustomer () {
      if (!this.canBeSubmitted) return
      const newCustomer = { ...this.customerSignUpForm }
      newCustomer.customerType = { id: this.customerType.id }
      newCustomer.offices = [{ ...this.officeForm }]
      newCustomer.offices[0].registrationNumber = this.customerSignUpForm.registrationNumber
      newCustomer.offices[0].admin = { ...this.adminOfficeInformation }
      newCustomer.offices[0].attorney = { ...this.attorney }

      try {
        await this.$store.dispatch('CustomersStore/createCustomer', newCustomer)
        Object.assign(this.$data, initialCustomerState)
        this.closeModal()
      } catch (error) {
        this.$v.$touch()
      }
    }
  },
  async created () {
    this.initializingConfig = false
  },

  validations: {
    customerType: {
      required
    },
    customerSignUpForm: {
      name: {
        required
      },
      registrationNumber: {
        required,
        alphaNum
      }
    },
    adminOfficeInformation: {
      firstName: { required },
      lastName: { required },
      email: { required, email }
    },
    attorney: {
      firstName: { required },
      lastName: { required },
      dateOfBirth: { required },
      country: { required },
      document: { required }
    },
    officeForm: {
      name: {
        required
      },
      address: {
        required
      },
      city: {
        required
      },
      zipCode: {
        required
      },
      country: {
        required
      },
      state: {
        required
      },

      fiscalAddress: {
        required
      },
      fiscalZipCode: {
        required
      },
      fiscalCity: {
        required
      },
      fiscalState: {
        required
      },
      currency: {
        id: {
          required
        }
      },

      fiscalCountry: {
        id: {
          required
        }
      }
    }

  }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
.ModalBox {
  &-header {
    z-index: 2;

    & > *:not(.tit) {
      z-index: 1;
    }
  }

  &-footer {
    z-index: 2;
  }
}

p {
  font-weight: 500;
  font-size: 1.1rem;
  margin-bottom: unset;
  margin-left: -10px;
}

.subcategory-title {
  font-size: 1rem;
  font-weight: 400;
}

.Form-field.required .Label:after {
  content: "*";
  color: red;
}
.input--block {
  padding: 0px 5px;
}
.Form--field-error {
  border: 1px solid red;
}

.input--error {
  border: 1px solid red;
  border-radius: 0.25rem;
}

.Form--field-multiselect {
  padding: 0px;
  margin: 0px;
}
</style>

<style lang="scss">
.multiselect-container >>> .multiselect__tags {
  position: relative;
  display: inline-block;
  padding: 0px;
  top: 0px;
  border-radius: 5px;
  margin-right: 0px;
  color: var(--text-heading);
  line-height: 1;
  background: var(--fill-text-area);
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.container-devoluiva-checkbox {
  padding: 0 5px;
  .checkbox-label {
    color: var(--text-body);
    font-size: 15px;
    line-height: 24px;
  }
}
</style>
